<template>
  <div class="inner-box">
    <div class="content-name">
      <h2 class="dp-ib">BOM관리</h2>
      <div style="float: right;">
        <el-button size="small" type="primary" icon="el-icon-search" @click="goOpen">{{ this.$i18n.messages[this.$store.state.locale].search }}</el-button>
        <el-button size="small" type="success" icon="el-icon-document-checked" @click="excelUpload">엑셀가져오기</el-button>
      </div>
    </div>
    <!-- 검색조건 영역 -->
    <div class="search-form">
      <el-form label-width="80px" @submit.native.prevent="goOpen">
        <el-row style="margin-bottom: 0px;">
          <el-col :span="8">
            <el-form-item label="모델명">
              <el-input size="small" type="text" v-model="form.modelNm"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 테이블 -->
    <div class="talbe-contain" style="display: flex;">
      <div class="table-area" style="margin-right: 50px; width: 30%;">
        <div class="table-b">
          <ag-grid-vue
              ref="gridMain"
              :style="gridStyle"
              class="ag-theme-alpine"
              rowSelection="single"
              :headerHeight="0"
              :rowModelType="rowModelType"
              :treeData="true"
              :isServerSideGroup="isServerSideGroup"
              :isServerSideGroupOpenByDefault="isServerSideGroupOpenByDefault"
              :getServerSideGroupKey="getServerSideGroupKey"
              :autoGroupColumnDef="autoGroupColumnDef"
              :animateRows="true"
              :rowData="data"
              :columnDefs="columnDefs"
              :defaultColDef="defaultColDef"
              :gridOptions="gridOptions"
              :suppressRowClickSelection="false"
              @grid-ready="onReadyMain"
              @selection-changed="onSelectionChangedMain"
          />
        </div>
      </div>
      <div class="table-area" style="width: 70%;">
        <div class="table-b">
          <ag-grid-vue
              ref="gridSub"
              style="width: 100%; height: 40vh; min-height: 25px;"
              class="ag-theme-alpine"
              row-selection="single"
              :columnDefs="columnDefsSub"
              :defaultColDef="defaultColDefSub"
              :frameworkComponents="frameworkComponents"
              :rowData="subData"
              :gridOptions="gridOptionsSub"
              :suppressRowClickSelection="false"
              :statusBar="statusBar"
              @grid-ready="onReadySub"
              @cell-value-changed="valueChange"
              @cell-clicked="clickDetailPopup"
          />
          <div class="table-header">
            <div style="float: right; margin: 5px 0 5px 0;">
              <el-button size="small" type="primary" icon="el-icon-document-add" @click="save">저장</el-button>
              <el-button size="small" type="danger" icon="el-icon-delete" @click="deleteRow">삭제</el-button>
            </div>
          </div>

          <ag-grid-vue
              ref="gridThird"
              style="width: 100%; height: 30vh; min-height: 25px;"
              class="ag-theme-alpine"
              :enableRangeSelection="true"
              :columnDefs="columnDefsThird"
              :defaultColDef="defaultColDefThird"
              :frameworkComponents="frameworkComponents"
              :rowData="tempData"
              :gridOptions="gridOptionsThird"
              :suppressRowClickSelection="false"
              @grid-ready="onReadyThird"
          />
          </div>

<!--          <bom-info ref="bomInfo" :bomDetail="bomdetail"/>-->


      </div>
      </div><!-- table contain -->
  </div>
</template>
<script>
import _ from "lodash";

import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer'
import common from '@/mixin/common';
import CallUploadExcel from "@/components/InfoManage/bomMng/CallUploadExcel";
import CallDetailInfo from "@/components/InfoManage/bomMng/CallDetailInfo";
import BomInfo from "@/components/InfoManage/BomInfo.vue";

/**
 * Url JOIN
 */
function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  mixins: [common],
  name: "codeMng",
  components: {BomInfo},
  data() {
    return {
      title: "",
      deleteid: "",
      deleteList: [],
      parentNm: "",
      bomDetail:[],
      modelData:[],
      form: {
        catKey: "",
        catNm: "",
        catId: "",
        parentId: "",
        topKey: "",
        catIdx: "",
        description: "",
        catValue1: "",
        catValue2: "",
        catValue3: "",
        catValue4: "",
        catValue5: "",
        modelNm : "",
      },
      defForm: {
        catKey: "",
        catNm: "",
        catId: "",
        parentId: "",
        topKey: "",
        catIdx: "",
        description: "",
        catValue1: "",
        catValue2: "",
        catValue3: "",
        catValue4: "",
        catValue5: "",
      },
      data: [],
      subData: [],
      tempData: [],
      gridOptions: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
        rowModelType: 'serverSide',
      },
      gridOptionsSub: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      gridOptionsThird: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      defaultColDefSub: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
        //cellStyle : {'justify-content': 'center','align-items': 'center', 'display': 'flex','height': '100%'}
      },
      defaultColDefThird: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      catDetail: [],
      gridApi: null,
      columnApi: null,
      columnDefs: [],
      gridApiSub: null,
      gridApiThird: null,
      columnApiSub: null,
      columnApiThird: null,
      columnDefsSub: [],
      columnDefsThird: [],
      frameworkComponents: null,
      autoGroupColumnDef: null,
      rowModelType: null,
      isServerSideGroupOpenByDefault: null,
      isServerSideGroup: null,
      getServerSideGroupKey: null,
      selectId : "",
      gridStyle : 'padding-top: 0px; width: 100%;height: 76.5vh; min-height:100px;',
    };
  },
  methods: {
    //메인그리드 Ready
    onReadyMain(params) {
      //메인그리드 api 정의
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.sizeColumnsToFit();
      this.init2();

      const updateData = (data) => {
        var fakeServer = this.createFakeServer(data);
        var datasource = this.createServerSideDatasource(fakeServer);
        params.api.setServerSideDatasource(datasource);
        return data;
      };
      this.$http.post(_url("/api/tree/bomMng/list"), {
        companyId: this.$store.state.loginInfo.compCd,
        processTime: ""
      }).then(response => {
        this.data = updateData(response.data);
      });
    },
    //서브그리드 Ready
    onReadySub(params) {
      //서브그리드 api 정의
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;

      this.gridApiSub.sizeColumnsToFit();
      this.autoSizeAll(this.columnApiSub);
    },
    onReadyThird(params) {
      //서브그리드 api 정의
      this.gridApiThird = this.gridOptionsThird.api;
      this.columnApiThird = this.gridOptionsThird.columnApi;

      this.autoSizeAll(this.columnApiThird);
    },
    autoSizeAll(columnApi) {
      const allColumnIds = [];
      columnApi.columnController.gridColumns.forEach((column) => {
        allColumnIds.push(column.getId());
      });
      columnApi.columnController.autoSizeColumns(allColumnIds, false);
    },
    //그리드컬럼 정의
    createColumnDefs() {
      const vm = this

      this.autoGroupColumnDef = {
        field: 'menu_nm',
        editable: false,
        cellRendererParams: {
          innerRenderer: (params) => {
            return params.data.menu_nm;
          },
        },
      };
      this.rowModelType = 'serverSide';
      this.isServerSideGroupOpenByDefault = (params) => {
        // open first two levels by default
        return params.rowNode.level < 1;
      };
      this.isServerSideGroup = (dataItem) => {
        // indicate if node is a group
        return dataItem.group;
      };
      this.getServerSideGroupKey = (dataItem) => {
        // specify which group key to use
        return dataItem.menu_id;
      };

      this.columnDefsSub = [
        {
          headerName: '선택'
          , field:'regYn'
          , width : 15
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: (params) => {
            return {trueValue: 'Y', falseValue: 'N', disable: (params.data.ifItemYn) === 'Y'}
          }
        },
        {headerName:'제조사', field:'makerNm', width:70, editable:false},
        {headerName:'제품군', field:'modelGroup', width:70, editable:false,
          valueFormatter: (params) => {
            return vm.getModelFormat(`${params.value}`);
          }
        },
        {headerName:'대표모델', field:'standardModelNm', width:70, editable:false},
        {headerName:'모델', field:'modelNm', width:70, editable:false},
        {headerName:'품번', field:'itemCd', width:70, editable:false},
        {headerName:'품명', field:'itemNm', width:200, editable:false},
        {headerName:'규격', field:'itemSpec', width:80, editable:false},
        {headerName:'생산일자', field:'prodDt', width:80, editable:false,
          valueFormatter: (params) => {
            return vm.getDateFormat(`${params.value}`)
          }
        },
        {headerName:'소요량', field:'itemQty', width:80, editable:false},
        {headerName:'버전', field:'verId', width:80, editable:false},
        {headerName:'I/F여부', field:'ifItemYn', width:80, editable:false},
        {headerName:'', field:'modelId', hide : true},
        {headerName:'', field:'itemId', hide : true},
      ]

      this.columnDefsThird = [
        {
          headerName: '선택'
          , field:'regYn'
          , width : 15
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: (params) => {
            return {trueValue: 'Y', falseValue: 'N'}
          }
        },
        {headerName:'제조사', field:'makerNm', width:70, editable:false},
        {headerName:'제품군', field:'modelGroup', width:70, editable:false,
          valueFormatter: (params) => {
            return vm.getModelFormat(`${params.value}`);
          }
        },
        {headerName:'대표모델', field:'standardModelNm', width:70, editable:false},
        {headerName:'모델', field:'modelNm', width:70, editable:false},
        {headerName:'품번', field:'itemCd', width:70, editable:false},
        {headerName:'품명', field:'itemNm', width:200, editable:true, headerClass: 'require-column',},
        {headerName:'규격', field:'itemSpec', width:80, editable:true, headerClass: 'require-column',},
        {headerName:'생산일자', field:'prodDt', width:80, editable:false,
          valueFormatter: (params) => {
            return vm.getDateFormat(`${params.value}`)
          }
        },
        {headerName:'소요량', field:'itemQty', width:80, editable:false},
        {headerName:'버전', field:'verId', width:80, editable:false},
        {headerName:'I/F여부', field:'ifItemYn', width:80, editable:false},
        {headerName:'', field:'modelId', hide : true},
        {headerName:'', field:'itemId', hide : true},
      ]
    },
    //Main 그리드 SelctionChange 발생
    onSelectionChangedMain(event) {

      if(this.form.modelNm != ''){
        const voRow = this.gridApi.getSelectedRows() //선택된 Row
        this.catDetail = this.defForm;
        this.parentNm = voRow[0].menu_nm;
        this.$store.commit('loading')
        this.$http
            .post("/api/bomMng/detail", {
              companyId: this.$store.state.loginInfo.compCd,
              modelGroup: voRow[0].menu_key,
              modelCd: this.form.modelNm,
              sortType : "",
              page : 1,
              totalPage : 9999,
              totalCount : 9999,
              curPage : 0,
              processTime : ""
            })
            .then(response => {
              this.subData = response.data
              this.selectId = voRow[0].menu_id;
            }).finally(() => {
          this.$store.commit('finish')
          this.autoSizeAll(this.columnApiSub);
        });
      }
    },
    onSelectionChangedSub(event) {
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;
      const voRow = this.gridApiSub.getSelectedRows() //선택된 Row

    },
    goOpen() {

      if(this.form.modelNm == ""){
        this.$swal({ type: 'error', text: '모델을 입력해주세요.' });
        return false;
      }


      const voRow = this.gridApi.getSelectedRows() //선택된 Row
      let modelGroup = voRow.length === 0 ? "" : voRow[0].menu_key;

      this.$store.commit('loading')
      this.$http
          .post("/api/bomMng/detail", {
            companyId: this.$store.state.loginInfo.compCd,
            modelGroup: modelGroup,
            modelCd: this.form.modelNm,
            sortType : "",
            page : 1,
            totalPage : 9999,
            totalCount : 9999,
            curPage : 0,
            processTime : ""
          })
          .then(response => {
            this.subData = response.data;
            this.selectId = voRow.length === 0 ? "" : voRow[0].menu_id;
          }).finally(() => {
        this.$store.commit('finish')
        this.autoSizeAll(this.columnApiSub);
      });

    },
    valueChange(params) {
      this.init();
    },
    clickDetailPopup(params) {
      const field = params.colDef.field;

      if(field == "regYn") return false;

      const vm = params.data
      this.$modal.open({
        component: CallDetailInfo,
        parent: this,
        props: {
          modelGroup: vm.modelGroup,
          modelCd: vm.modelCd,
          modelId: vm.modelId,
          itemId: vm.itemId,
          sortType : "",
          page : 1,
          totalPage : 9999
        },
        events: {
          close(data) {
          },
        }
      });
    },
    save() {

      let submitList = [];

      this.tempData.forEach(x=>{
        submitList.push({
          companyId : x.companyId,
          itemId : x.itemId,
          itemNm : x.itemNm,
          itemSpec : x.itemSpec,
          updatorId : this.$store.state.loginInfo.id
        })
      })

      this.$store.commit('loading')
      this.$http.post(_url("/api/bomMng/detail/save"), submitList
      ).then(response => {
        this.$swal({ type: 'success', text: '수정 되었습니다.' });
        this.goOpen();
      }).catch(({ message }) => {
        this.$store.commit('finish');
        this.$swal({ type: "error", text: "오류가 발생했습니다." });
      }).finally(() => {
      });
    },
    deleteRow() {

      const grid = this.$refs.gridThird;

      this.submitList = [];

      const chkDatas = grid.rowData.filter((x,i) => {
        return x.ifItemYn === "Y"
      })

      const chkDatas2 = grid.rowData.filter((x,i) => {
        return x.regYn === "Y"
      })

      if(chkDatas.length > 0){
        this.$swal({ type: 'error', text: '인터페이스 여부를 체크하세요.'});
        return false;
      }

      if(chkDatas2.length == 0){
        this.$swal({ type: 'error', text: '삭제 여부를 체크하세요.'});
        return false;
      }

      let submitList = [];

      chkDatas2.forEach(x=>{
        submitList.push({
          companyId : x.companyId,
          modelId : x.modelId,
          itemId : x.itemId,
          verId : x.verId
        })
      })

      this.$store.commit('loading')
      this.$http.post(_url("/api/bomMng/detail/delete"), submitList
      ).then(response => {
        this.$swal({ type: 'success', text: '삭제 되었습니다.' });
        this.tempData = [];
        this.goOpen();
      }).catch(({ message }) => {
        this.$store.commit('finish');
        this.$swal({ type: "error", text: "오류가 발생했습니다." });
      }).finally(() => {
      });

    },
    getModelFormat(val){
      let value = ""
      this.modelData.forEach(x=>{
        if(x.key === val) value = x.value;
      })
      console.log(value);
      return value;
    },
    getDateFormat(val) {
      if (val) {
        return val === 'null' ? '' : this.$moment(val).format('YYYY-MM-DD')
      }
    },
    excelUpload(){
      /** 엑셀업로드 */
      let vm = this;
      this.$modal.open({
        width: 800,
        component: CallUploadExcel,
        parent: this,
        props: {
          data: {

          },
        },
        events: {
          close(param) {
            vm.form.maker = param.data.maker /** 제조사 */
            vm.form.makerNm = param.data.makerNm /** 제조사명 */
            vm.form.modelGroupNm = param.data.modelGroupNm /** 모델그룹명 */
            vm.form.modelGroup = param.data.modelGroup /** 모델그룹 */
            vm.form.standardModelNm = param.data.standardModelNm /** 표준모델 */
            vm.form.modelNm = param.data.modelNm /** 모델명 */
            vm.form.modelId = param.data.modelId /** 모델ID */
            vm.goOpen();
            vm.tempData = [];
          },
        }
      });

    },
    init() {
      const grid = this.$refs.gridSub;

      this.submitList = [];

      const chkDatas = grid.rowData.filter((x,i) => {
        return x.regYn === "Y"
      })

      for(var i=0; chkDatas.length > i; i++){
        this.submitList.push({
          companyId: this.$store.state.loginInfo.compCd,
          makerNm: chkDatas[i].makerNm,
          modelGroup: chkDatas[i].modelGroup,
          standardModelNm: chkDatas[i].standardModelNm,
          modelId: chkDatas[i].modelId,
          modelNm: chkDatas[i].modelNm,
          itemId: chkDatas[i].itemId,
          itemCd: chkDatas[i].itemCd,
          itemNm: chkDatas[i].itemNm,
          itemSpec: chkDatas[i].itemSpec,
          prodDt : chkDatas[i].prodDt,
          itemQty: chkDatas[i].itemQty,
          verId: chkDatas[i].verId,
          ifItemYn: chkDatas[i].ifItemYn,
          updatorId: this.$store.state.loginInfo.id,
          processTime: ""
        });
      }
      this.tempData = this.submitList;
    },
    init2(){
      this.$store.commit('loading');
      this.$http.post(`/api/bomMng/init`)
          .then(response => {
            this.modelData = response.data.modelGroup;
          }).finally(() => {
        //this.goOpen();
        this.$store.commit('finish');
      });
    },
    cancel(){
      // CatInfo 초기화
    },
    createFakeServer(ServerData) {
      const Server = {
        data: ServerData,
        getData: function (request) {
          function extractRowsFromData(groupKeys, data) {
            if (groupKeys.length === 0) {
              return data.map(function (d) {
                var has_inner_menu = d.inner_menu.length == 0? false : true;
                return {
                  group:  has_inner_menu,
                  menu_id: d.menu_id,
                  menu_nm: d.menu_nm,
                  menu_key: d.menu_key,
                };
              });
            }
            var key = groupKeys[0];
            for (var i = 0; i < data.length; i++) {
              if (data[i].menu_id === key) {
                return extractRowsFromData(
                    groupKeys.slice(1),
                    data[i].inner_menu.slice()
                );
              }
            }
          }
          return extractRowsFromData(request.groupKeys, this.data);
        },
      };
      return Server;
    },
    createServerSideDatasource(fakeServer) {
      const dataSource = {
        getRows: (params) => {

          var allRows = fakeServer.getData(params.request);
          var request = params.request;
          var doingInfinite = request.startRow != null && request.endRow != null;
          var result = doingInfinite
              ? {
                rowData: allRows.slice(request.startRow, request.endRow),
                rowCount: allRows.length,
              }
              : { rowData: allRows };
          setTimeout(function () {
            params.success(result);
          }, 200);
        },
      };
      return dataSource;
    }
  },
  beforeMount() {

    this.createColumnDefs(); //그리드 컬럼정의 함수 호출

    this.frameworkComponents = {//그르드에서 사용할 외부 comp 등록
      checkboxRenderer: CheckboxCellRenderer,
    };

  },
  mounted() {
    //this.goOpen();
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
};

</script>